<template>
    <div class="entity-page-component">
        <div class="tool-bar" >
            <div>
                <v-btn  flat icon light :to="backLink" active-class  ><v-icon>arrow_back</v-icon></v-btn>
                <span class="title">{{ $t("message.Back") }}</span>
            </div>
            <div>
                <v-btn flat icon light v-on:click="save"><v-icon>done</v-icon></v-btn>
            </div>
        </div>

        <div class="entity-page" :style="{ 'min-height': computedPageHeight}">
            <div class="header">
               <v-icon large >business</v-icon>
                <div class="fullname" >{{ companyName }}</div> 
            </div>
            <v-tabs slider-color="secondary" class="app-tabs">
                <v-tab ripple>General</v-tab>
                <v-tab ripple>People</v-tab>
                <v-tab-item>
                    <v-text-field v-model="companyName" :label="$t('message.Name')"></v-text-field>
                    <label>{{ $t('message.Description')}}</label>
                    <textarea v-model="companyDescription" ></textarea>
                </v-tab-item>
                <v-tab-item></v-tab-item>
            </v-tabs> 
        </div>
        <v-snackbar
            v-model="showmessage"
            bottom="bottom"
            right="right"
            :timeout="6000"
            >
            <span>{{ alertMessage }}</span>
            <v-btn v-on:click="showmessage = false" flat icon dark><v-icon>close</v-icon></v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import GenericRepository from "../../services/GenericRepository.js";
import CompaniesRepository from "../../services/CompaniesRepository.js";
import HAL from "../../helpers/HAL.js";

export default {
    name: "CompanyPage",
    computed: {
        computedPageHeight: function() {
            return this.pageHeight + 'px';
        }
    },
    data() {
        return {
            pageHeight: 10,
            companyName: '',
            companyDescription: '',
            organizationId: null,
            companyId: null,
            updateLink: null,
            insertLink: '/api/companies',
            backLink: '/companies',
            showmessage: false,
            alertMessage: ''
        }
    },
    methods: {
        goBack() {
            return '/companies';
        },
        save() {
            var entity = {
                "companyId": this.companyId,
                "description": this.companyDescription,
                "name": this.companyName
            }
            if(entity.companyId > 0) {
                GenericRepository.update(this.updateLink.href, entity).then(function(response) {
                    if(response.data && response.data.status == 'Success')  {
                        window.vm.$router.push(this.goBack());
                        this.$emit("save");
                    }
                    else {
                        this.alertMessage = response.data.message;
                        this.showmessage = true;
                    }
                 }.bind(this));
            }
            else {
                GenericRepository.insert(this.insertLink, entity).then(function(response) {
                    if(response.data && response.data.status == 'Success')  {
                        window.vm.$router.push(this.goBack());
                        this.$emit("save");
                    }
                    else {
                        this.alertMessage = response.data.message;
                        this.showmessage = true;
                    }
                 }.bind(this));
            }
        }
    },
    created() {
        this.pageHeight = window.innerHeight - 57 - 25 - 25;
        
        CompaniesRepository.getCompaniesByID(this.$route.params.id).then(function (response) {
            if(response.data && response.data.status == 'Success')  {
                this.companyName = response.data.name;
                this.companyDescription = response.data.description;
                this.organizationId = response.data.organizationId;
                this.companyId = response.data.companyId;
                this.updateLink = HAL.getLink(response.data, 'help:company-update');
                
            }
        }.bind(this));
    }
}
</script>


<style lang="stylus">
    @import '../../assets/css/tool-bar.css'
    @import '../../assets/css/entity-page.css'
</style>
